customError = require 'error-ext'

module.exports = customError 'PollTimeoutError'



// WEBPACK FOOTER //
// ./app/scripts/views/billing/internal/poll-timeout-error.coffee